export const addCredObjToLocalStorage = (credObj) => {
    localStorage.setItem('credObj', JSON.stringify(credObj));
};
export const getCredObjFromLocalStorage = () => {
    const result = localStorage.getItem('credObj');
    const credObj = result ? JSON.parse(result) : null;
    return credObj; 
};
export const removeCredObjsFromLocalStorage = () => {
    localStorage.clear();
};
export const addAgeGroup = (obj) => {
    localStorage.setItem('ageGroupOpt', JSON.stringify(obj)); 
}
export const getAgeGroupOpt = () => {
    let opt = localStorage.getItem("ageGroupOpt");
    let obj = {
        name:'',
        isSelected:false
    }
    obj = JSON.parse(opt);
    if (!obj) {
        return {name:'',isSelected:false};
    }
    return obj;
};
export const addEducationLevel = (key, value) => {
    localStorage.setItem(key, value);
}
export const getEducationLvl = (key) => {
    let grade = localStorage.getItem(key);
    if (grade === null || grade === undefined) return '';
    return grade;
}
export const addBookTitle = (title) => {
    localStorage.setItem("book-title", title)
}
export const getBookTitle = () => {
    let title = localStorage.getItem("book-title");
    if (title === undefined || title === null) return ''
    return title;
}
export const addBookAuthor = (author) => {
    localStorage.setItem('book-author', author);
}
export const getBookAuthor = () => {
    let author = localStorage.getItem("book-author");
    if (author === undefined || author === null) return ''
    return author;
}
export const storeCurrentParagraph = (paragraph) => {
    localStorage.setItem('paragraph', paragraph);
}
export const getCurrentPargraph = () => {
    let paragraph = localStorage.getItem('paragraph');
    if (paragraph === undefined || paragraph === null) return ""
    return paragraph;
};
export const clearCurrentParagraph = () => {
    localStorage.removeItem('paragraph');
}
export const storeListOfParagraph = (list) => {
    localStorage.setItem('paragraph-list', JSON.stringify(list));
}
export const getListOfParagraph = () => {
    let list = localStorage.getItem('paragraph-list');
    let paragraphs = list ? JSON.parse(list) : [];
    return paragraphs;
}
export const clearFormFromLocalStorage = () => {
    localStorage.removeItem('ageGroupOpt');
    localStorage.removeItem('book-cover');
    localStorage.removeItem('book-title');
    localStorage.removeItem('book-author');
    localStorage.removeItem('paragraph');
    localStorage.removeItem('paragraph-list');
};
export const addCurrentBookIdToLocalStorage = (id) => {
    localStorage.setItem('book-id', id);
};
export const getCurrentBookIdFromLocalStorage = () => {
    return localStorage.getItem('book-id');
};